module.exports = __webpack_public_path__ + "img/1.b357fd48.svg";